// ── FAQ TOGGLE ───────────────────────────────────────────────────
function toggleFaq(el) {
  var item = el.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  
  // Close all items first
  document.querySelectorAll('.faq-item').forEach(function(i) {
    i.classList.remove('open');
    var answer = i.querySelector('.faq-answer');
    if (answer) answer.style.display = 'none';
  });
  
  // If it wasn't open, open it now
  if (!isOpen) {
    item.classList.add('open');
    var answer = item.querySelector('.faq-answer');
    if (answer) answer.style.display = 'block';
  }
}

// Open the first FAQ item by default on page load
document.addEventListener('DOMContentLoaded', function() {
  var firstItem = document.querySelector('.faq-item');
  if (firstItem) {
    firstItem.classList.add('open');
    var firstAnswer = firstItem.querySelector('.faq-answer');
    if (firstAnswer) firstAnswer.style.display = 'block';
  }
});

// ── STICKY BAR ───────────────────────────────────────────────────
var stickyBar = document.getElementById('stickyBar');
if (stickyBar) {
  window.addEventListener('scroll', function() {
    if (window.scrollY > 600) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  });
}

// ── NAV SCROLL EFFECT ────────────────────────────────────────────
var navbar = document.getElementById('navbar');
if (navbar) {
  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      navbar.style.background = 'rgba(10,15,10,0.98)';
    } else {
      navbar.style.background = 'rgba(17,26,15,0.97)';
    }
  });
}

// ── FORM SUBMIT ───────────────────────────────────────────────────
function handleSubmit() {
  var btn = document.querySelector('.form-submit');
  if (btn) {
    btn.textContent = 'Received — We will contact you within 24 hours';
    btn.style.background = 'var(--accent)';
    btn.style.color = 'var(--dark)';
    btn.disabled = true;
  }
}

// ── SCROLL REVEAL ────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .why-card, .step, .testimonial, .math-card').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});